(function () {
  'use strict';

  angular
    .module('crewSignInScreen')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewSignInScreen', {
        url: '/crew-sign-in-screen',
            templateUrl: 'crew-sign-in-screen/views/crew-sign-in-screen.tpl.html',
            controller: 'CrewSignInScreenCtrl',
            controllerAs: 'crewSignInScreen'

      });
  }
}());
